import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestigationTypeRepository } from '../../../infrastructure/repositories/investigation-type.repository';
import { GetActiveInvestigationTypesResult } from './get-active-investigation-types.result';

@Injectable({ providedIn: 'root' })
export class GetActiveInvestigationTypesUseCase {
  private readonly _investigationTypeRepository = inject(InvestigationTypeRepository);

  public execute(): Observable<GetActiveInvestigationTypesResult> {
    return this._investigationTypeRepository
      .getActiveInvestigationTypes()
      .pipe(map((investigationTypes) => ({ investigationTypes })));
  }
}
